import { createContext } from 'react'
import CreationToolError from '../../types/error'

type CreationToolsWelcomeContextProps = {
    error?: CreationToolError
    errorSource?: File | string
    setError: (error?: CreationToolError) => void
    setErrorSource: (source?: File | string) => void
    onFileAdded?: (files: FileList) => void
}

export const CreationToolsWelcomeContext = createContext({} as CreationToolsWelcomeContextProps)
